// GENERATED by scripts/icons/generate_icons.py. Do not edit by hand.
import { createIcon } from "./createIcon";

export const ArrowEnterIcon = /*#__PURE__*/ createIcon("ArrowEnter", "M7.5 17a.5.5 0 0 1 0-1H14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H7.5a.5.5 0 0 1 0-1H14a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3zm.15-10.85c.2-.2.5-.2.7 0l3.5 3.5c.2.2.2.5 0 .7l-3.5 3.5a.5.5 0 0 1-.7-.7l2.64-2.65H1.5a.5.5 0 0 1 0-1h8.8L7.64 6.85a.5.5 0 0 1 0-.7");
